import { Component, Input, Output, OnChanges, EventEmitter, SimpleChanges, ElementRef, ViewChild, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { FormGroup, FormGroupDirective, Validators } from "@angular/forms";
import { NgbTypeaheadConfig } from '@ng-bootstrap/ng-bootstrap';
import { GeoService } from 'src/app/services/geo.service';
import { MiscService } from 'src/app/services/misc/misc.service';
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, finalize, forkJoin, from, lastValueFrom, map } from "rxjs";
import { mandatoryPincodeCountries, pincodePattern, TelephoneNumberValidation } from 'src/app/models/validator';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppCoreService } from 'src/app/services/app-core.service';
import { AddressBookService } from 'src/app/services/general/addressbook.service';
import { CustomerService } from 'src/app/services/customer.service';
import { Utilities } from 'src/app/models/utilities';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnChanges, AfterViewInit {
  @Input() formGroupName: string;
  @Input() formSubmitted: boolean = false;
  @Input() address: any;
  @Input() fieldType: string = '';
  @Input() conditionalCountryList = [];
  @Input() productFilteredCountryList = [];
  @Output() pincodeChild = new EventEmitter<void>();
  @Output() getAddress = new EventEmitter<any>();
  @Input() listType: 'origin' | 'destination' = 'origin';
  @Output() getSelectedAddressKycInfo = new EventEmitter<any>();
  @Output() byLocationChange = new EventEmitter<any>();

  @ViewChild('name') name!: ElementRef;

  @ViewChild('country') countryField!: NgSelectComponent;
  @Output() focusEmit = new EventEmitter<boolean>();

  @Input() focusConsigneeName: boolean = false;
  @Input() focusCheckHide: boolean = true;
  @Output() addressBookListEmit: any = new EventEmitter<any>();
  @Output() emitAddressCheck = new EventEmitter<any>();

  @Input() countryList: any[];

  awbAddressFocusCheckMap: any;

  addressDetailsForm: FormGroup;

  @ViewChildren(
    'country, name, contactPerson, email,' +
    'pincode, state,' +
    'city, address1, address2, area, mobileNo, telephoneNo'
  )
  fields!: QueryList<any>;

  getCheckedStatus(fieldKey: string): boolean {
    return this.awbAddressFocusCheckMap?.find(item => item.key === fieldKey)?.value ?? false;
  }

  ngAfterViewInit(): void {
    this.awbAddressFocusCheckMap = this.userData.metaInfo.userconfig.awbaddressfocuscheckmap;
  }

  toggleFieldCheck(fieldKey: string, isChecked: boolean) {
    const field = this.awbAddressFocusCheckMap?.find(item => item.key === fieldKey);
    if (field) {
      field.value = isChecked;
      this.emitAddressCheck.emit(this.awbAddressFocusCheckMap);
    }
  }

  focusNextField(currentField?: string) {
    let nextField;

    // If no currentField is provided, find the first field with value: true
    if (!currentField) {
      nextField = this.awbAddressFocusCheckMap?.reduce((min, item) =>
        item.value && (!min || item.no < min.no) ? item : min, null);
    } else {
      // Find the current field based on `key`
      const currentItem = this.awbAddressFocusCheckMap?.find(item => item.key === currentField);
      if (!currentItem) return; // Exit if not found

      const currentNo = currentItem.no;

      // Find the next field with the smallest `no` that has `value: true`
      nextField = this.awbAddressFocusCheckMap?.find(item => item.no > currentNo && item.value);
    }
    
    // If there's no next field, emit event and exit
    if (!nextField) {
      this.focusEmit.emit();
      return;
    }

    // Check if the field should be focused
    setTimeout(() => {
      const field = this.fields.find(el =>
        (el instanceof NgSelectComponent && el.element.id === nextField.key) ||
        (el instanceof ElementRef && el.nativeElement.id === nextField.key)
      );

      if (field instanceof NgSelectComponent) {
        if (!field.disabled) {
          field.focus();
        } else {
          this.focusNextField(nextField.key); // Skip disabled field
        }
      } else if (field instanceof ElementRef) {
        if (!field.nativeElement.disabled) {
          field.nativeElement.focus();
        } else {
          this.focusNextField(nextField.key); // Skip disabled field
        }
      } else {
        this.focusEmit.emit(); // If no valid next field, emit event
      }
    });
  }

  _address: any[] = [];
  // countryList: any[] = [];
  stateList: any[] = [];
  cityList: any[] = [];
  pincodeList: any[] = [];
  resPincodeList: any[] = [];
  areaList = [];
  selectedAddress: any;
  countryCode: any;
  shipperLocationInfo: any;
  addressBookList: any[] = [];
  userData: any;

  isCountryMandate = false;
  isStateMandate = false;
  isCityMandate = false;
  isAreaMandate = false;
  isAddressMandate = false;
  isMobileMandate = false;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  resAddressBookList = [];
  consigneeLocationInfo: any;
  filteredOrigin: any = [];
  filteredDestination: any = [];
  originCountryList: any;
  resCountryList: any = [];
  minPincode: number;
  maxPincode: number;
  useEnterKey = false;
  constructor(
    private rootFormGroup: FormGroupDirective,
    private geoService: GeoService,
    private miscService: MiscService,
    private typeaheadConfig: NgbTypeaheadConfig,
    private ngxLoader: NgxUiLoaderService,
    private appCoreService: AppCoreService,
    private addressbookService: AddressBookService,
    private customerService: CustomerService,
    private utilities: Utilities,

  ) {
    // typeaheadConfig.showHint = true;
  }

  ngOnInit(): void {
    this.addressDetailsForm = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
    this.checkPermission();
    window.addEventListener('focusConsigneeNameEvent', () => this.name.nativeElement.focus());
    if (this.permConfig.isViewAllowed) {
      // this.addressDetailsForm.get('ddlCountry').valueChanges.subscribe(newValue => {
      //   this.pincodeList = this.resPincodeList.filter(x => x.countryisocode === newValue);
      // });
      // this.loadDataFromAPI();

      // based on country change update addressbook list
      this.addressDetailsForm.get('ddlCountry').valueChanges.pipe(distinctUntilChanged()).subscribe(country => {
        // console.log('country', country);
        if (country) {
          this.loadDataFromAPI(country, this.listType);
        }
      });
      this.resCountryList = this.countryList;
      this.conditionalCountryList = this.countryList;
      this.productFilteredCountryList = this.countryList;
    }
  }

  async ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      const change = changes[propName];
      if (change.firstChange) {
        return; // Skip the first change after initialization
      }
    }

    if (changes['focusConsigneeName'] && this.focusConsigneeName) {
      if (this.name) {
        this.name.nativeElement.focus();
      }
    }

    // filter product based country list
    if (this.listType === 'destination' && changes['productFilteredCountryList']) {
      // listtype is maintained for origin and destination
      this.countryList = changes['productFilteredCountryList'] && changes['productFilteredCountryList']?.currentValue;
      if (this.countryList?.length == 1) {
        this.addressDetailsForm.get('ddlCountry').setValue(this.countryList?.[0]?.isocode);
        this.bindStatesByCountry(this.countryList?.[0]?.isocode);
        this.addressDetailsForm.get('ddlCountry').disable();
        this.addressDetailsForm.get('ddlCountry').markAsDirty();
      } else {
        Object.keys(this.addressDetailsForm.controls).forEach(controlName => { this.addressDetailsForm.get(controlName).reset() });
        this.addressDetailsForm.get('ddlCountry').enable();
        this.addressDetailsForm.get('ddlCountry').markAsUntouched();
        this.stateList = [];
        this.cityList = [];
        this.pincodeList = [];
        this.addressBookList = [];
      }
    }

    const ud: any = this.appCoreService.GetUserData();
    if (ud && ud.accessType == "Customer") {
      this.filteredOrigin = changes?.conditionalCountryList?.currentValue?.[0]?.data;
      this.filteredDestination = changes?.conditionalCountryList?.currentValue?.[1]?.data;
      // console.log('listtype', this.listType);
      if (this.conditionalCountryList && this.conditionalCountryList.length > 0) {
        if (this.listType === 'origin') {

          this.countryList = this.resCountryList.filter(c =>
            this.filteredOrigin?.some(item => item.country === c.code)
          );

          const stateFilteredOrigin = this.conditionalCountryList[0].data;
          this.stateList = this.stateList.filter(c =>
            stateFilteredOrigin?.some(item => item.state === c.code)
          )
          const cityFilteredOrigin = this.conditionalCountryList[0].data;
          this.cityList = this.cityList.filter(c =>
            cityFilteredOrigin?.some(item => item.city === c.code)
          )
        }
        if (this.listType === 'destination') {

          this.countryList = this.resCountryList.filter(c =>
            this.filteredDestination?.some(item => item.country === c.code)
          );

          const stateFilteredDestination = this.conditionalCountryList[1].data;
          this.stateList = this.stateList.filter(c =>
            stateFilteredDestination.some(item => item.state === c.code)
          )

          const cityFilteredDestination = this.conditionalCountryList[1].data;
          this.cityList = this.cityList.filter(c =>
            cityFilteredDestination.some(item => item.city === c.code)
          )

        }
      }
    }

    this.addressDetailsForm = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
    // changes.prop contains the old and the new value...
    this.setFieldValidations();
    if (changes['address'] && changes['address'].currentValue) {
      let choosenAddress = changes['address'].currentValue.location;
      let info = changes['address'].currentValue.info;
      let bookiId = changes['address'].currentValue?.bookid;
      // console.log("changes", changes);

      this.selectedAddress = choosenAddress;
      // console.log('selectedAddress---', this.selectedAddress);

      if (this.selectedAddress?.locationapply) {
        let country: any, state: any, city: any;
        const loc = this.selectedAddress.locationapply;
        country = this.countryList.filter((item) => item.code == loc.country)[0]?.isocode;
        // console.log('country---', country);

        this.bindStatesByCountry(country).then(() => {

          state = this.stateList.filter((item) => item.code == loc.state)[0]?.isocode;
          // console.log('state---',state);

          this.bindCitiesByState(state).then(() => {
            city = this.cityList.filter((item) => item.code == loc.city)[0]?.isocode;
            this.addressDetailsForm.patchValue({
              ddlCountry: country,
              ddlState: state,
              ddlCity: city
            })
          })
        });
      }

      let selectedLocArea = (typeof this.selectedAddress?.area === 'string') ? { area: this.selectedAddress?.area } : this.selectedAddress?.area;
      let selectedLocPincode = (typeof this.selectedAddress?.pincode === 'string' || typeof this.selectedAddress?.pincode === 'number') ? { pincode: this.selectedAddress?.pincode } : this.selectedAddress?.pincode;

      //
      let selectdObj = bookiId ? this.addressBookList.find(x => x.id === bookiId) : info;

      if (this.selectedAddress?.country !== this.addressDetailsForm.get('ddlCountry').value)
        await this.bindStatesByCountry(this.selectedAddress?.country);

      if (this.selectedAddress?.state !== this.addressDetailsForm.get('ddlState').value)
        await this.bindCitiesByState(this.selectedAddress?.state);

      this.addressDetailsForm.patchValue({
        txtContactPerson: info?.contactperson,
        txtEmail: info?.emailid,
        txtName: selectdObj || (info?.name ? { name: info?.name } : null),
        ddlCountry: this.selectedAddress?.country,
        ddlState: this.selectedAddress?.state,
        ddlCity: this.selectedAddress?.city,
        txtPincode: selectedLocPincode,
        txtAddress1: this.selectedAddress?.address1,
        txtAddress2: this.selectedAddress?.address2,
        txtArea: selectedLocArea,
        txtMobileNo: this.selectedAddress?.mobileno,
        txtTelephoneNo: this.selectedAddress?.tel,
      });
      // this.bindPincodes();
      // this.setPincodeValidation();
    }
  }

  onCountryChange() {
    const selectedValue = this.addressDetailsForm.get('ddlCountry').value;
    this.addressDetailsForm.get('ddlState').reset();
    this.addressDetailsForm.get('ddlCity').reset();
    this.addressDetailsForm.get('txtPincode').reset();
    this.stateList = [];
    this.cityList = [];
    this.pincodeList = [];
    this.setFieldValidation('ddlState');
    this.setFieldValidation('ddlCity');
    this.setFieldValidation('txtPincode');
    this.setFieldValidations();
    if (selectedValue) {
      this.bindStatesByCountry(selectedValue);
      this.bindCitiesByCountry(selectedValue);
    }
    // filter shipper and consignee based on country
    this.addressBookList = selectedValue && this.resAddressBookList.filter(a => a.location.country === selectedValue);
    this.pincodeList = this.resPincodeList.filter(x => x.countryisocode === selectedValue);
    // console.log('x.countryisocode === selectedValue', selectedValue);
    
    // console.log('pincodeList', this.pincodeList);
    // console.log('resPincodeList', this.resPincodeList);
    
    this.setPincodeValidation();
  }

  loadDataFromAPI(countryCode?: string, listType?: string) {
    try {
      // this.ngxLoader.start();
      forkJoin({
        // countries: this.geoService.GetAllCountries(),
        addressbook: this.addressbookService.GetAll({ industrytypeid: null, isactive: true, customerid: this.userData?.metaInfo?.customerid, countryisocode: countryCode }),
        areas: this.miscService.GetAllAreas(),
        pincodes: this.geoService.GetAllPincodes({ countryisocode: this.addressDetailsForm.get('ddlCountry').value }),
      }).pipe(
        finalize(() => {
          //get pincode over default country
          // this.ngxLoader.stop();
          this.pincodeList = this.resPincodeList.filter(x => x.countryisocode === this.addressDetailsForm.get('ddlCountry')?.value || this.appCoreService.GetUserData()?.metaInfo.defaultcountry);
          this.setPincodeValidation();
        })
      ).subscribe((res) => {
        if (res) {
          // if (res.countries.success && res.countries?.data?.length) {
          //   this.countryList = res.countries?.data;
          //   this.resCountryList = res.countries?.data;
          //   if (this._address.length)
          //     this._address[0]["country"] = this.countryList;
          //   else
          //     this._address.push({ "country": this.countryList });

          //   this.getAddress.emit(this._address);
          //   }
          //   if (metaInfo.operationtype.includes('Domestic') && metaInfo.operationtype.includes('International')) {
          //     this.countryList = this.resCountryList;
          //   } else if (metaInfo.operationtype.includes('Domestic')) {
          //     this.countryList = this.resCountryList.filter(item => item.isocode === defaultCountryCode);
          //     if (this.countryList?.[0]?.isocode) {
          //       this.addressDetailsForm.get('ddlCountry').setValue(this.countryList?.[0]?.isocode);
          //       // if domestic call states
          //       this.bindStatesByCountry(defaultCountryCode);
          //       this.addressDetailsForm.get('ddlCountry').disable();
          //     }
          //   } else if (metaInfo.operationtype.includes('International')) {
          //     this.countryList = this.resCountryList.filter(item => item.isocode !== defaultCountryCode);
          //   }

          //   if (this._address.length)
          //     this._address[0]["country"] = this.countryList;
          //   else
          //     this._address.push({ "country": this.countryList });

          //   this.getAddress.emit(this._address);
          // }

          if (this._address.length)
            this._address[0]["country"] = this.countryList;
          else
            this._address.push({ "country": this.countryList });

          this.getAddress.emit(this._address);

          // this.ngxLoader.stop();
          if (res.areas.success && res.areas?.data?.length) {
            this.areaList = res.areas?.data;
          }
          if (res.addressbook.success && res.addressbook?.data?.length) {
            this.addressBookList = res.addressbook?.data.sort((a, b) => Number(a.disabled) - Number(b.disabled));
            this.resAddressBookList = res?.addressbook.data;
            if(listType){
              this.listType === 'origin' ? this.filteredOrigin = this.addressBookList : this.filteredDestination = this.addressBookList;
            }
            this.addressBookListEmit.emit({ addressbook: this.addressBookList, listType: listType });
          }
          if (res.pincodes.success && res.pincodes?.data?.length) {
            this.pincodeList = res.pincodes?.data;
            this.resPincodeList = res.pincodes?.data;
          }
        }
      })
    } catch (error) {
      // this.ngxLoader.stop();
    }
  }

  checkPermission(): any {
    this.userData = this.appCoreService.GetUserData();
    this.useEnterKey = !this.userData.metaInfo.tabbasedtemplate;
    const permission = this.userData.config.filter(x => x.categoryname === 'AirWayBills');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  onChangeTelephone() {
    const inputValue = this.addressDetailsForm.get('txtTelephoneNo')?.value;

    if (inputValue) {
      const formattedValue = inputValue
        .split(',')
        .map((part) => part.trim()) // Trim each part
        .filter((part) => part !== '') // Remove empty parts
        .join(', ');

      // Update the form control with the formatted value
      this.addressDetailsForm.get('txtTelephoneNo')?.setValue(formattedValue, { emitEvent: false });
    }
  }

  preventChars(event: any) {
    this.addressDetailsForm.get('txtTelephoneNo').setValue(event.target.value.replace(/[^0-9,]/g, ''))
  }

  setPincodeValidation() {
    if (this.addressDetailsForm) {
      const pincodeControl = this.addressDetailsForm.get('txtPincode');
      const matchedCountryCode = this.countryList.find(x => x.isocode === this.countryCode)?.code;
  
      if (pincodeControl) {
        let validators = [];
  
        const isMandatory = matchedCountryCode && mandatoryPincodeCountries.includes(matchedCountryCode);
  
        // Add 'required' validator if the country requires it
        if (isMandatory) {
          validators.push(Validators.required);
        }

        // Apply pattern/length validation only if value is present (i.e., user entered something)
        if (typeof pincodeControl?.value === 'string') {
          if (matchedCountryCode && pincodePattern[matchedCountryCode]) {
            const pattern = pincodePattern[matchedCountryCode];

            this.minPincode = 0
            this.maxPincode = 0
            this.minPincode = this.utilities.getMinLength(pattern);
            this.maxPincode = this.utilities.getMaxLength(pattern);
  
            validators.push(
              Validators.pattern(pattern),
              Validators.minLength(this.minPincode),
              Validators.maxLength(this.maxPincode)
            );
          } else {
            // Fallback validator only when value exists
            pincodeControl.clearValidators();
          }
        }
        pincodeControl.setValidators(validators);
        pincodeControl.updateValueAndValidity();
      }
    }
  }

  // async bindlocationByPincode(event: any) {
  //   try {
  //     this.addressDetailsForm?.get('txtPincode')?.clearValidators();
  //     this.addressDetailsForm.get('txtPincode').updateValueAndValidity();
  //     if (event) {
  //       // this.maxLength(1000);
  //       const pinObj = event.item;
  //       const foundPincode = this.pincodeList.filter((x: any) => pinObj.pincode == x.pincode);
  //       // this.ngxLoader.start();
  //       if (foundPincode?.length > 0) {
  //         this.addressDetailsForm.get('ddlCountry').setValue(pinObj.countryisocode);
  //         // Used from to convert promises to observables before lastValueFrom
  //         await lastValueFrom(from(this.bindStatesByCountry(pinObj.countryisocode)));
  //         await lastValueFrom(from(this.bindCitiesByState(pinObj.stateisocode)));
  //         this.addressDetailsForm.get('ddlState').setValue(pinObj.stateisocode);
  //         this.addressDetailsForm.get('ddlCity').setValue(pinObj.cityisocode);
  //       }
  //       // this.ngxLoader.stop();
  //       this.pincodeChild.emit();
  //     } else {
  //       this.setPincodeValidation();
  //     }
  //   } catch (error) {
  //     // this.ngxLoader.stop();
  //     console.error(error);
  //   }
  // }

  async bindAddressByPincode(event: any) {
    try {
      this.addressDetailsForm?.get('txtPincode')?.clearValidators();
      if (event) {
        const pinObj = event.item;
        this.addressDetailsForm.get('txtPincode').clearValidators();
        this.addressDetailsForm.get('txtPincode').updateValueAndValidity();
        const foundPincode = this.pincodeList.filter((x: any) => pinObj.pincode == x.pincode);
        // this.ngxLoader.start();
        if (foundPincode?.length > 0) {
          this.addressDetailsForm.get('ddlCountry').setValue(pinObj.countryisocode);
          // Used from to convert promises to observables before lastValueFrom
          await lastValueFrom(from(this.bindStatesByCountry(pinObj.countryisocode)));
          await lastValueFrom(from(this.bindCitiesByState(pinObj.stateisocode)));
          this.addressDetailsForm.get('ddlState').setValue(pinObj.stateisocode);
          this.addressDetailsForm.get('ddlCity').setValue(pinObj.cityisocode);
        }
        // this.ngxLoader.stop();
        this.pincodeChild.emit();
      }
    } catch (error) {
      // this.ngxLoader.stop();
      console.error(error);
    }
  }

  setFieldValidation(controlName: string) {
    const control = this.addressDetailsForm.controls[controlName];
    // const requiredControls = Object.keys(this.addressDetailsForm.controls).filter(controlName => {
    //   const control = this.addressDetailsForm.get(controlName);
    //   return control?.errors?.required;
    // });
    // console.log('requiredControls',requiredControls);
    const isMandate = control?.errors?.required ? true : false;
    if (isMandate) {
      switch (controlName) {
        case 'ddlCountry':
          this.isCountryMandate = isMandate;
          break;
        case 'ddlState':
          this.isStateMandate = isMandate;
          break;
        case 'ddlCity':
          this.isCityMandate = isMandate;
          break;
        case 'txtArea':
          this.isAreaMandate = isMandate;
          break;
        case 'txtAddress1':
          this.isAddressMandate = isMandate;
          break;
        case 'txtMobileNo':
          this.isMobileMandate = isMandate;
          break;
        default:
          this.isCountryMandate = true;
          // this.isStateMandate = true;
          // this.isCityMandate = true;
          // this.isAreaMandate = true;
          this.isAddressMandate = true;
          this.isMobileMandate = true;
          break;
      }
      this.addressDetailsForm.get(controlName).setValidators([Validators.required]);
    } else {
      this.addressDetailsForm.get(controlName).clearValidators();
    }

    this.addressDetailsForm.get(controlName).updateValueAndValidity();
  }

  setFieldValidations() {
    this.setPincodeValidation();
    this.setFieldValidation('ddlCountry');
    this.setFieldValidation('txtName');
    // this.setFieldValidation('ddlState');
    // this.setFieldValidation('ddlCity');
    // this.setFieldValidation('txtArea');
    this.setFieldValidation('txtAddress1');
    // this.setFieldValidation('txtMobileNo');
    //set mobile validation - issue formControl validation parent-to-child
    // this.addressDetailsForm.get('txtMobileNo').addValidators([MobileNumberValidation]);
    this.addressDetailsForm.get('txtTelephoneNo').addValidators([TelephoneNumberValidation]);
    // this.addressDetailsForm.get('txtMobileNo').updateValueAndValidity();
    this.addressDetailsForm.get('txtTelephoneNo').updateValueAndValidity();
  }

  async bindStatesByCountry(countryCode?: string): Promise<void> {
    try {
      if (countryCode?.length) {

        const observable = this.geoService.GetAllStates({ countrycode: countryCode });
        const res = await lastValueFrom(observable);

        if (res && res.success) {
          this.stateList = res.data;
          this.countryCode = countryCode;
          const ud: any = this.appCoreService.GetUserData();
          if (ud && ud.accessType == "Customer") {

            if (this.conditionalCountryList && this.conditionalCountryList.length > 0) {
              if (this.listType === 'origin') {
                const stateFilteredOrigin = this.conditionalCountryList[0].data;
                this.stateList = this.stateList.filter(c =>
                  stateFilteredOrigin?.some(item => item.state === c.code)

                )
                // console.log('this.stateList', this.stateList)
              } else if (this.listType === 'destination') {
                const stateFilteredDestination = this.conditionalCountryList[1].data;
                this.stateList = this.stateList.filter(c =>
                  stateFilteredDestination.some(item => item.state === c.code)
                )
              };
            }

          }

          //this._address.push({"state": this.stateList});

          if (this._address.length)
            this._address[0].state = this.stateList;
          else
            this._address.push({ "state": this.stateList });

          // this.getAddress.emit(this._address);
        } else {
          throw new Error('Error fetching states');
        }
      }
      this.getAddress.emit(this._address);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  onStateChange(changedby: string) {
    const selectedValue = this.addressDetailsForm.get('ddlState').value;
    this.addressDetailsForm.get('ddlCity').reset();
    this.cityList = [];
    if (selectedValue) {
      this.bindCitiesByState(selectedValue);

      this.getAddress.emit(this._address);
      changedby === 'byLocationChange' && this.byLocationChange.emit(true);
    }
    else {
      const selectedValue = this.addressDetailsForm.get('ddlCountry').value;
      this.bindCitiesByCountry(selectedValue);

      this.getAddress.emit(this._address);
      changedby === 'byLocationChange' && this.byLocationChange.emit(true);
    }
  }

  async bindCitiesByCountry(countryIsoCode?: string): Promise<void> {
    try {
      // console.log("BINDCITIESBYCOUNTRYISOCODE", countryIsoCode);
      if (countryIsoCode?.length) {
        const observable = this.geoService.GetAllCities({ countryisocode: countryIsoCode });
        const res = await lastValueFrom(observable);

        if (res && res.success) {
          this.cityList = res.data;
          const ud: any = this.appCoreService.GetUserData();
          if (ud && ud.accessType == "Customer") {
            if (this.conditionalCountryList && this.conditionalCountryList.length > 0) {
              if (this.listType === 'origin') {
                const cityFilteredOrigin = this.conditionalCountryList[0].data;
                this.cityList = this.cityList.filter(c =>
                  cityFilteredOrigin?.some(item => item.city === c.code)
                )
              }
              else if (this.listType === 'destination') {
                // console.log('working')
                // console.log('this.conditionalCountryList', this.conditionalCountryList)
                const cityFilteredDestination = this.conditionalCountryList[1].data;
                this.cityList = this.cityList.filter(c =>
                  cityFilteredDestination.some(item => item.city === c.code)
                )
              }

            }
          }
          //this._address.push({"city": this.cityList});
          if (this._address.length)
            this._address[0].city = this.cityList;
          else
            this._address.push({ "city": this.cityList });

          this.getAddress.emit(this._address);
        } else {
          throw new Error('Error fetching cities');
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async bindCitiesByState(stateCode?: string): Promise<void> {
    try {
      if (stateCode?.length) {
        const observable = this.geoService.GetAllCities({ statecode: stateCode });
        const res = await lastValueFrom(observable);

        if (res && res.success) {
          this.cityList = res.data;
          const ud: any = this.appCoreService.GetUserData();
          if (ud && ud.accessType == "Customer") {
            if (this.conditionalCountryList && this.conditionalCountryList.length > 0) {
              if (this.listType === 'origin') {
                const cityFilteredOrigin = this.conditionalCountryList[0].data;
                this.cityList = this.cityList.filter(c =>
                  cityFilteredOrigin?.some(item => item.city === c.code)
                )
              }
              else if (this.listType === 'destination') {
                // console.log('working')
                // console.log('this.conditionalCountryList', this.conditionalCountryList)
                const cityFilteredDestination = this.conditionalCountryList[1].data;
                this.cityList = this.cityList.filter(c =>
                  cityFilteredDestination.some(item => item.city === c.code)
                )
              }

            }
          }
          //this._address.push({"city": this.cityList});
          if (this._address.length)
            this._address[0].city = this.cityList;
          else
            this._address.push({ "city": this.cityList });

          this.getAddress.emit(this._address);
        } else {
          throw new Error('Error fetching cities');
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  onCityChange() {
    if (this.addressDetailsForm.get('ddlCity').value)
      this._address[0].city = this.cityList?.filter(x => x.isocode === this.addressDetailsForm.get('ddlCity').value);
    else
      this._address[0].city = [];

    this.getAddress.emit(this._address);
  }

  bindAreas() {
    try {
      this.miscService.GetAllAreas().subscribe((res) => {
        // console.log('areas', res);
        if (res && res.success) {
          this.areaList = res.data;
          // console.log(this.addressDetailsForm.get('txtArea').value);
        } else {
          // handle some error
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  bindPincodes() {
    try {
      this.geoService.GetAllPincodes().subscribe((res) => {
        // console.log('pincode data', res);
        if (res && res.success) {
          this.pincodeList = res.data;
          this.resPincodeList = res.data;
          // console.log(this.addressDetailsForm.get('txtArea').value);
        } else {
          // handle some error
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  searchArea: OperatorFunction<string, readonly { area: string }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.areaList?.filter((v) => v.area.toLowerCase().includes(term.toLowerCase())).slice(0, 10)
      )
    );

  // search = (text$: Observable<string>) => {
  //   const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
  //   return merge(debouncedText$).pipe(
  //     map(term => (term === '' ? this.areaList
  //       : this.areaList.filter(v => v.area.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
  //   );
  // }

  areaFormatter = (x: { area: string }) => x.area;

  searchPincode: OperatorFunction<string, readonly { pincode; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.pincodeList?.filter((v) => v.pincode.toLowerCase().startsWith(term.toLowerCase())).slice(0, 10),
      ),
    );

  pincodeFormatter = (x: { pincode: string }) => x.pincode;

  selectedItemEvent(item) {
    try {
      this.bindLocationDetails(item.item);
      this.getSelectedAddressKycInfo.emit(item?.item?.kycinfo);
      // this.shipper = item.item;
    } catch (e) {

    }
  }

  async bindLocationDetails(currLoc) {
    try {
      // console.log("currLoc", currLoc);
      this.addressDetailsForm.get('txtContactPerson').setValue(currLoc?.contactperson ?? null);
      this.addressDetailsForm.get('txtEmail').setValue(currLoc?.emailid ?? null);
      this.addressDetailsForm.get('txtAddress1').setValue(currLoc.location.address1 ?? null);
      this.addressDetailsForm.get('txtAddress2').setValue(currLoc.location.address2 ?? null);
      this.addressDetailsForm.get('txtArea').setValue(currLoc.location ?? null);
      this.addressDetailsForm.get('txtMobileNo').setValue(currLoc.location.mobileno ?? null);
      this.addressDetailsForm.get('txtTelephoneNo').setValue(currLoc.location.tel ?? null);
      this.addressDetailsForm.get('txtPincode').setValue(currLoc.location ?? null);
      currLoc?.location && this.addressDetailsForm.get('txtPincode').markAsDirty();
      this.addressDetailsForm.get('ddlCountry').setValue(currLoc.location.country ?? null);
      currLoc?.location?.country && this.addressDetailsForm.get('ddlCountry').markAsDirty();

      // await lastValueFrom(from(this.bindStatesByCountry(currLoc.location.country)));
      // await lastValueFrom(from(this.bindCitiesByState(currLoc.location.state)));

      if (currLoc.location.country !== this.addressDetailsForm.get('ddlCountry').value)
        await lastValueFrom(from(this.bindStatesByCountry(currLoc.location.country)));

      if (currLoc.location.state !== this.addressDetailsForm.get('ddlState').value)
        await lastValueFrom(from(this.bindCitiesByState(currLoc.location.state)));

      this.addressDetailsForm.get('ddlState').setValue(currLoc.location.state ?? null);
      currLoc?.location?.state && this.addressDetailsForm.get('ddlState').markAsDirty();
      this.addressDetailsForm.get('ddlCity').setValue(currLoc.location.city ?? null);
      currLoc?.location?.state && this.addressDetailsForm.get('ddlCity').markAsDirty();

      // console.log("currLoc.location.state", currLoc.location.state);

      this.shipperLocationInfo = {
        country: currLoc.location.country,
        state: currLoc.location.state,
        city: currLoc.location.city,
        area: currLoc.location.area,
        address1: currLoc.location.address1,
        address2: currLoc.location.address2,
        pincode: currLoc.location.pincode,
        mobileno: currLoc.location.mobileno,
        tel: currLoc.location.tel,
      };

      this.consigneeLocationInfo = {
        country: currLoc.location.country,
        state: currLoc.location.state,
        city: currLoc.location.city,
        area: currLoc.location.area,
        address1: currLoc.location.address1,
        address2: currLoc.location.address2,
        pincode: currLoc.location.pincode,
        mobileno: currLoc.location.mobileno,
        tel: currLoc.location.tel,
      };
    }
    catch (e) {
      console.error(e);
    }
  }

  search: OperatorFunction<string, readonly { name; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.addressBookList?.filter((v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  formatter = (x: { name: string }) => x.name;

  focusFirstField() {
    // this.utilities.focusFirstElement(this.addressDetailsForm)
    this.focusNextField();
  }

}